import { useRouter } from "next/router";

import { removeAllCookies } from "@/utils/remove";
import styled from "styled-components";
import { useSupabaseClient } from "@supabase/auth-helpers-react";
import Link from "next/link";
import Image from "next/image";

const Login = ({
  toggleModal,
  title,
  slug,
}: {
  toggleModal: () => void;
  title: string;
  slug: string;
}) => {
  const router = useRouter();
  const supabaseClient = useSupabaseClient();

  const signInWithGoogle = async function () {
    await removeAllCookies();
    const { data, error } = await supabaseClient.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: `https://instantapply.co/auth-callback?from=app&route=/sites&${slug}=true`,
      },
    });
  };

  //handler function for signin with Google
  async function handleAuth() {
    await signInWithGoogle();
  }

  return (
    <LoginContainer onClick={(e) => e.stopPropagation()}>
      <div>
        <Image
          onClick={toggleModal}
          width={40}
          height={40}
          src="/assets/images/cancel.svg"
          className="mr-1 h-10 sm:h-9 "
          alt="InstantApply Logo"
        />
        <span className="self-center  font-silka text-md text-gray-500 font-medium  whitespace-nowrap dark:text-white">
          InstantApply
        </span>
      </div>
      <h1 className="text-md">{title}</h1>
      <p>Welcome to InstantApply</p>
      <button
        onClick={handleAuth}
        className="flex mt-8 w-[300px] h-[60px] border border-gray-600 bg-white hover:scale-105 transition-all  text-gray-600 items-center justify-center rounded-md "
      >
        <svg
          className="mr-2 h-6 w-6"
          aria-hidden="true"
          focusable="false"
          data-prefix="fab"
          data-icon="github"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path
            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            fill="#4285F4"
          />
          <path
            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            fill="#34A853"
          />
          <path
            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            fill="#FBBC05"
          />
          <path
            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            fill="#EA4335"
          />
          <path d="M1 1h22v22H1z" fill="none" />
        </svg>
        Sign In With Google
      </button>
    </LoginContainer>
  );
};

const LoginContainer = styled.div`
  background-color: #fff;
  border-radius: 10px;
  width: 80%;
  max-width: 650px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 32px 10px;
  box-shadow: 1px 1px 10px rgba(255, 255, 255, 0.4);
  position: relative;
  svg {
    max-width: 50px;
  }
  img {
    width: 5rem;
    transform-origin: 100% 0;
    opacity: 1;
    position: absolute;
    top: 1rem;
    right: 1rem;
    transform: scale(0.28);
  }
  h1 {
    font-weight: 700;
    font-size: 24px;
    text-align: center;
    color: #202021;

    span {
      display: block;
      margin-bottom: 0.5em;
      color: var(--primary-color);
    }
    @media (min-width: 768px) {
      font-size: 32px;
    }
  }

  p {
    font-weight: 400;
    font-size: 16px;
    color: #626569;
    margin: 1.5em;
    @media (min-width: 768px) {
      font-size: 24px;
    }
  }

  .google-logo {
    margin-right: 0.8em;
    font-weight: 700;
    height: 30px;
  }
`;

export default Login;
